import actions from '@/store/faq/actions';

const faqModule = {
  state: () => ({
    isLoading: false,
    error: null,
    faqPage: {},
    isLoadingTemplates: false,
    faqTemplates: [],
  }),
  mutations: {
    GET_FAQ_BY_PAGE_START(state) {
      state.isLoading = true;
      state.error = null;
    },
    GET_FAQ_BY_PAGE_SUCCESS(state, payload) {
      state.faqPage = payload;
      state.isLoading = false;
      state.error = null;
    },
    GET_FAQ_BY_PAGE_FAILURE(state, data) {
      state.isLoading = false;
      state.faqPage = {};
      state.error = data;
    },

    GET_FAQ_TEMPLATES_START(state) {
      state.isLoadingTemplates = true;
      state.error = null;
    },
    GET_FAQ_TEMPLATES_SUCCESS(state, payload) {
      state.faqTemplates = payload;
      state.isLoadingTemplates = false;
      state.error = null;
    },
    GET_FAQ_TEMPLATES_FAILURE(state, data) {
      state.isLoadingTemplates = false;
      state.faqTemplates = [];
      state.error = data;
    },
  },
  actions,
  namespaced: true,
};

export default faqModule;
